<template>
    <div class="text-left">
        {{text}}
        <slot></slot>
    </div>

</template>

<script>
    export default {
        name: 'TextBlock',
        props: {
            text: String
        }
    }
</script>`